module.exports = __webpack_public_path__ + "img/ИФ-1(А)-024.ca3fd6ba.png";